import { stringify } from 'query-string';
import fetchJson from '../lib/react-admin-loopback/fetch';

// /schedules/dashboardCurations?queryParams={“today”:“20210115"}
export async function reqSchedules() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      order: 'date ASC'
    }),
    // 개발 & 테스트할 땐 주석 해제 
    /* queryParams: JSON.stringify({
      today: '20210115'
    }), */
    clientType: 'bo'
  };
  const url = `${apiUrl}/schedules/dashboardCurations?${stringify(params)}`;
  const { json } = await fetchJson(url);
  return {
    data: json
  };
}

export async function reqOrderUpdate( params) {
  const apiUrl = process.env.REACT_APP_API_URL;
  
  const { json } = await fetchJson(
    `${apiUrl}/schedules/dashboard`,
    {
      method: 'PATCH',
      body: JSON.stringify(params)
    }
  );
  return {
    data: json
  };
}

export async function reqCustomers(page = 1, perPage = 10 , check =[0,1,2,3]) {

  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: (page - 1) * perPage
    }), 
    queryParams: JSON.stringify({
      status: check
    }), /**/
    clientType: 'bo'
  };
  const url = `${apiUrl}/schedules/dashboardOrders?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: json.length
  };
}